import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

const VisibilityWrapper = ({children, visible}) => {

    if (!visible) {
        return null;
    }

    return <Fragment>{children}</Fragment>;
};

VisibilityWrapper.propTypes = {
    visible: PropTypes.bool,
};

VisibilityWrapper.defaultProps = {
    visible: true
};

export default VisibilityWrapper;
